import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const ModalOwnerContainer = styled(Box, {
	zIndex: 501, // drawer zIndex is 500
});
